import React from "react";
import SwipeDelete from "../../../Reusable/SwipeDelete";

interface ResultItemProps {
  secondary: string;
  main: string;
  image: string;
  logo: string;
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
  index: number;
  onDelete: (index: number) => void;
}

const TenantCard = ({
  main,
  secondary,
  logo,
  onClick,
  index,
  onDelete,
}: ResultItemProps) => (
    <SwipeDelete index={index} onDelete={onDelete} onClick={onClick}>
      <div className="ls__locationCard" onClick={onClick}>
        <div className="ls__locationCard_left--oht">
          <img
            src={logo}
            alt={main}
            className="ls__locationCard_image"
          />
        </div>
        <div className="ls__locationCard_right">
          <p className="ls__locationCard_cityprovince">{main}</p>
          <p className="ls__locationCard_postalcode">{secondary}</p>
        </div>
      </div>
    </SwipeDelete>
  );

export default TenantCard;
